// frontend/src/components/NotificationBar.js
import React, { useState, useEffect } from 'react';
import { Alert, Snackbar, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { notificationsApi } from '../services/apiClient';import { useThemeSettings } from "../contexts/ThemeContext";

const NotificationBar = () => {const { t } = useThemeSettings();
  const [notifications, setNotifications] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(null);

  useEffect(() => {
    // Load unread system/admin notifications on mount
    const fetchNotifications = async () => {
      try {
        const response = await notificationsApi.getAll();
        if (response.data && response.data.notifications) {
          // Filter for unread system/admin notifications only
          // These are notifications marked with 'system' type or have 'showInBar' flag
          const systemNotifications = response.data.notifications.filter(
            (notif) => !notif.read && (notif.type === 'system' || notif.showInBar === true)
          );

          setNotifications(systemNotifications);

          // If there are system notifications, show the first one
          if (systemNotifications.length > 0) {
            setCurrentNotification(systemNotifications[0]);
            setOpenSnackbar(true);
          }
        }
      } catch (error) {
        console.error('Failed to fetch notifications:', error);
      }
    };

    fetchNotifications();

    // Set up polling interval
    const interval = setInterval(fetchNotifications, 2 * 60 * 1000); // Check every 2 minutes

    return () => clearInterval(interval);
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleMarkAsRead = async () => {
    if (currentNotification) {
      try {
        await notificationsApi.markAsRead(currentNotification.id);

        // Remove this notification from the array
        const updatedNotifications = notifications.filter(
          (notif) => notif.id !== currentNotification.id
        );

        setNotifications(updatedNotifications);
        setOpenSnackbar(false);

        // Show the next notification if there is one
        if (updatedNotifications.length > 0) {
          setTimeout(() => {
            setCurrentNotification(updatedNotifications[0]);
            setOpenSnackbar(true);
          }, 500);
        } else {
          setCurrentNotification(null);
        }
      } catch (error) {
        console.error('Failed to mark notification as read:', error);
      }
    }
  };

  return (
    <>
      {currentNotification &&
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>

          <Alert
          onClose={handleClose}
          className="notification-enter"
          severity={currentNotification.type || 'info'}
          sx={{ width: '100%' }}
          action={
          <>
                <IconButton
              size="small"
              aria-label={t ? t("NotificationBar.mark_as_read") : "mark as read"}
              color="inherit"
              onClick={handleMarkAsRead}>
              
                  <CloseIcon fontSize="small" />
                </IconButton>
              </>
          }>
          
            {currentNotification.message}
          </Alert>
        </Snackbar>
      }
    </>);

};

export default NotificationBar;